import * as service from './service'
export default {
  namespace: 'accidentTransferTransferApply',
  state: {
    demoData: {}
  },
  effects: {
    * transferCheck ({ payload }, { call, put }) {
      const { data } = yield call(service.transferCheck, payload)
      if (data.status === 200) {
        return data.data
      } else {
        return Promise.reject()
      }
    },

    * transferSubmit ({ payload }, { call, put }) {
      const { data } = yield call(service.transferSubmit, payload)
      if (data.status === 200) {
        return data.data
      } else {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
